const stamp=value=>value==null?NaN:new Date(value).getTime();
export function ownerDayViewRows(timeline={},dateKey,offset=new Date().getTimezoneOffset()){
 const start=Date.parse(`${dateKey}T00:00:00Z`)+Number(offset)*60000,end=start+86400000;
 const pending=(timeline.items||[]).filter(x=>['activity','parallel_activity'].includes(x.kind)&&x.meta?.staleUnverified)
  .slice().sort((a,b)=>Number(b.kind==='parallel_activity')-Number(a.kind==='parallel_activity'));
 const events=(timeline.items||[]).filter(x=>!x.meta?.staleUnverified&&
  (x.lane==='actual'||x.lane==='calendar'||x.lane==='plan'||x.kind==='life'));
 const gaps=(timeline.gaps||[]).filter(x=>Number(x.minutes)>=5).map((x,i)=>({...x,
  id:`gap:${i}:${x.startAt}`,kind:'gap',lane:'gap',title:'Sin dato',detail:'Completar con lo que realmente hiciste'}));
 const records=[...events,...gaps].map(x=>{
  const a=stamp(x.startAt),b=x.point?a:stamp(x.endAt);
  if(!Number.isFinite(a)||a>=end||(Number.isFinite(b)&&(x.point?b<start:b<=start))||a<start&&!Number.isFinite(b))return null;
  const from=Math.max(0,(a-start)/60000),to=Number.isFinite(b)?Math.min(1440,(b-start)/60000):from;
  return {...x,from,to,point:Boolean(x.point||!Number.isFinite(b)||to<=from)};
 }).filter(Boolean).sort((a,b)=>a.from-b.from||a.to-b.to);
 return {pending,records};
}
export function layoutOwnerDayColumns(records=[]){
 const output=[];let cluster=[],until=-1;
 const flush=()=>{
  const ends=[];
  for(const row of cluster){let col=ends.findIndex(x=>x<=row.from);if(col<0)col=ends.length;
   ends[col]=Math.max(row.to,row.from+22);output.push({...row,column:col,columns:0});}
  for(let i=output.length-cluster.length;i<output.length;i++)output[i].columns=ends.length;
  cluster=[];
 };
 for(const row of records){if(cluster.length&&row.from>=until)flush();
  cluster.push(row);until=Math.max(cluster.length===1?-1:until,row.to,row.from+22);}
 if(cluster.length)flush();return output;
}
